import React, { useState } from "react";
import { Link } from "react-router-dom";
import useLang from "../hooks/useLang";
import LanguageSwitcher from "../components/LanguageSwitcher";
import Logo from "../components/Logo";
import api from "../api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { ArrowLeft, EnvelopeSimple } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success(t("resetEmailSent"));
    } catch (err) {
      toast.error(err.response?.data?.detail || t("errorGeneric"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col dot-grid">
      <div className="flex justify-end p-6"><LanguageSwitcher small /></div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm animate-fade-up">
          <div className="flex flex-col items-center mb-10"><Logo size="md" /></div>
          <div className="bg-white border border-zinc-200 rounded-md p-8">
            <div className="overline mb-3">/// Password Reset</div>
            <h2 className="font-heading text-2xl tracking-tight mb-1">{t("forgotPasswordTitle")}</h2>
            <p className="text-zinc-500 text-sm mb-8">{t("forgotPasswordSubtitle")}</p>
            {sent ? (
              <div className="border border-zinc-200 rounded-md p-6 bg-zinc-50 flex gap-3 items-start" data-testid="forgot-sent-msg">
                <EnvelopeSimple size={22} weight="light" className="shrink-0 mt-0.5" />
                <p className="text-sm text-zinc-700">{t("resetEmailSent")}</p>
              </div>
            ) : (
              <form onSubmit={submit} className="space-y-5">
                <div className="space-y-2">
                  <Label className="overline">{t("email")}</Label>
                  <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" className="rounded-md border-zinc-200 h-11" />
                </div>
                <Button type="submit" disabled={loading} data-testid="forgot-submit-btn" className="w-full h-11 bg-zinc-950 hover:bg-zinc-800 rounded-md font-medium">
                  {loading ? t("loading") : t("sendResetLink")}
                </Button>
              </form>
            )}
          </div>
          <Link to="/login" className="flex items-center justify-center gap-2 text-sm text-zinc-500 hover:text-zinc-950 mt-6" data-testid="back-to-login">
            <ArrowLeft size={14} /> {t("login")}
          </Link>
        </div>
      </div>
    </div>
  );
}
